/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SwitchToV4Container_user$ref: FragmentReference;
declare export opaque type SwitchToV4Container_user$fragmentType: SwitchToV4Container_user$ref;
export type SwitchToV4Container_user = {|
  +id: string,
  +$refType: SwitchToV4Container_user$ref,
|};
export type SwitchToV4Container_user$data = SwitchToV4Container_user;
export type SwitchToV4Container_user$key = {
  +$data?: SwitchToV4Container_user$data,
  +$fragmentRefs: SwitchToV4Container_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SwitchToV4Container_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '9dd8311fd31a2c0c7af6e94e41485e76';
module.exports = node;
